import getProductKey from 'helper/requests/getProductKey';

const ROUTE_PRODUCT_MAP: Record<string, string> = {
  '/agro/similarity': 'agro',
  '/meteorology/weather/similarity': 'meteorologia',
};

export default function getProductFromPath(
  pathname: string = window.location.pathname,
) {
  const match = Object.keys(ROUTE_PRODUCT_MAP).find((route) => pathname.includes(route));

  return match ? getProductKey(ROUTE_PRODUCT_MAP[match]) : '';
}
